import {
  FLOODING_INACTIVE_LABELS_MIN_ZOOM,
  INACTIVE_FLOODING_ICONS_LAYER_ID,
  INACTIVE_FLOODING_LABELS_LAYER_ID,
  INACTIVE_FLOODING_SOURCE_ID,
} from './FloodingsLayer.constants';
import { FloodingsLayerBase, FloodingsLayerConfig } from './FloodingsLayerBase';
import { FloodingsLayerProps } from './FloodingsLayer.utils';

const config: FloodingsLayerConfig = {
  sourceId: INACTIVE_FLOODING_SOURCE_ID,
  iconsLayerId: INACTIVE_FLOODING_ICONS_LAYER_ID,
  labelsLayerId: INACTIVE_FLOODING_LABELS_LAYER_ID,
  labelsMinZoom: FLOODING_INACTIVE_LABELS_MIN_ZOOM,
  filterEvent: (e) => !e.isActive,
};

export const InactiveFloodingsLayer = (
  props: FloodingsLayerProps,
): JSX.Element => <FloodingsLayerBase {...props} config={config} />;
